import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TIMELINE_ENTITY_TYPE } from '../../../../../interfaces/timeline.interface';

/** History of the chat (title and manager changes) in the stacked sidebar */
@Component({
  selector: 'app-chat-timeline',
  templateUrl: './chat-timeline.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  host: { class: 'block h-full min-h-0' },
})
export class ChatTimelineComponent {
  protected readonly TIMELINE_ENTITY_TYPE = TIMELINE_ENTITY_TYPE;

  @Input() chatId?: string;
  @Input() chatTitle?: string | null;
  @Output() close = new EventEmitter<void>();
}
